import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useMemo } from "react";
import { AnalyticsProvider } from "@/libs/analytics";
import { createAnalyticsConfig } from "@/libs/analytics/config";

/**
 * Layout of the Birdwatch pay page (`/pay/<token>`), opened from an emailed or
 * texted link without a login. Deliberately OUTSIDE the `(member)` group: no
 * member layout, no Google Tag Manager, no support chat.
 *
 * The token is the payer's only credential, so Mixpanel, the one provider
 * here, never sends the page's URL or the referrer (Known trap 30). The config
 * is built once per mount: `new MixpanelProvider` calls `mixpanel.init`.
 */
export const Route = createFileRoute("/(pay)")({
  component: PayLayout,
});

function PayLayout() {
  const config = useMemo(
    () =>
      createAnalyticsConfig({
        allowedProviders: ["mixpanel"],
        propertyBlacklist: ["$current_url", "$referrer"],
      }),
    [],
  );

  return (
    <AnalyticsProvider config={config}>
      <Outlet />
    </AnalyticsProvider>
  );
}
